var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isAdminPage)?_c('Nav'):_vm._e(),_c('main',{staticClass:"main-content"},[_c('router-view')],1),(!_vm.isAdminPage)?_c('Footer',{staticClass:"footer"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }